import { render, staticRenderFns } from "./TermsDriver.vue?vue&type=template&id=a24b0e9c"
import script from "./TermsDriver.vue?vue&type=script&lang=js"
export * from "./TermsDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports